import React, {Component} from "react"
import {Link} from 'gatsby'
import {
	Button,
	Form,
	Input,
	Header,
	Message,
	Segment
} from 'semantic-ui-react'
import * as styles from './styles/forms.module.css'
import {
	confirmationColor,
	backColor,
	secondaryButtonColor,
	//activateAccountColor,
	redirectGuestCheckoutColor
} from '../../globalVar'

import SignInForm from './signInForm'
import SignUpForm from './SignUpForms/signUpForm'

const Negosyo = require('../../../lib/negosyo')

export default class loginSubmissionForm extends Component {
	state={
		loginStage: "",
		loggedIn:undefined,
		user:null,
		name:this.props.guestname?this.props.guestname:"",
		contact:this.props.guestmobile?this.props.guestmobile:"",
		email:this.props.guestemail?this.props.guestemail:"",
		loading:false,
		loadingContact:false, //mobile
		loadingContactInfo:false, //loading for contact Info stage when user is submitting the contact details for the order
		errorDisplay:'',
		success:null,
		timeOutRef:null,
		errorMessage: {
			name:null,
			contact:null,
			email:null
		}
	}

	componentWillUnmount() {
		clearTimeout(this.state.timeOutRef)
	}

	componentDidMount() {
		let stage = "";

		if (this.props.hasOwnProperty('guestmobile')) {
			stage = this.props.guestmobile.length > 0 ? "proceed" : "sign in";
		} else if (this.props.hasOwnProperty('loginStage')) {
			stage = this.props.loginStage.length > 0 ? this.props.loginStage : "sign in"
		} else {
			stage = "sign in"
		}

		this.setState({loginStage: stage})
        this.handleUserLogIn();
	}

    submitUserinfo = (submitusername) => {
		this.setState({
			loadingContactInfo:false
		}, function() {
			this.props.handleProceed(this.state.name,this.state.contact,this.state.email, submitusername);
		});
    }

	handleUserLogIn = () => {
		this.setState({
			loadingContact:true,
		});
		Negosyo.isLoggedIn()
		.then((isLoggedIn)=>{
			if(isLoggedIn) {
				this.setState({
					loggedIn:true
				},()=>{
					//this.scrollToTopSection()
				})
				Negosyo.getCurrentUserDetails()
				.then((user)=>{
					this.setState({
						user:user,
					})
					if (this.props.handleSignIn) {
						this.props.handleSignIn(user.username);
					}

					/* No need to proceed with other API calls if there is no passed handleProceed func and not autoproceed
					 * For example, for sign-in and register, it will navigate to another page after signing in so no need
					 * to call the next APIs
					 */ 
					if (this.props.hasOwnProperty("autoproceedonsignin")) {
						if (!this.props.autoproceedonsignin) return;
					} 

					if (this.props.hasOwnProperty('handleProceed')) {
						if (this.props.handleProceed === null) return;
					}

					Negosyo.getUserProfile(user.username).then((response)=>{
						if(response.status==="OK") {
							this.setState(prevState => ({
								name:response.data.name,
								profile: {
									...prevState.profile, //prevent race conditions with other api in the future that will also set values for profile
									name:response.data.name
								}
							}))
						}
						Negosyo.getContactList(user.username).then((response)=> {
							if(response.status==="OK") {
								var responseidx = 0;
								var primaryemail = "";
								var primarymobile = "";
								while (responseidx < response.data.length) {
									if( response.data[responseidx].contact.indexOf("@") >= 0 ) {
										if (primaryemail.length < 1 || response.data[responseidx].contact.verified === true) {
											primaryemail = response.data[responseidx].contact;
										}
									}else {
										//mobile number
										if (primarymobile.length < 1 || response.data[responseidx].contact.verified === true) {
											primarymobile = response.data[responseidx].contact;
										}
									}
									responseidx = responseidx + 1;
								}
								this.setState({
									contact:primarymobile,
									email:primaryemail,
									loadingContact:false
								}, function() {
									if (this.props.hasOwnProperty("autoproceedonsignin")) {
										if (this.props.autoproceedonsignin) {
											this.submitUserinfo(user.username);
										}
									}
								});
							}else {
								this.setState({
									loadingContact:false
								})
							}
						}).catch((err)=>{
							this.setState({
								loadingContact:false
							});
						}) // get contact
					}).catch((err)=>{
						// Name not loaded
						this.setState({
							loadingContact:false
						});
					}) // get profile (name)
				}).catch((err)=>{
					this.setState({
						loadingContact:false
					});
				}); // get user details
			} else {
				this.setState({
					loadingContact:false
				});
			} // logged in or not
		}).catch((err)=>{
			this.setState({
				loadingContact:false
			});
		}); // check is logged in
		this.setState({
			menuMessage:undefined
		})
	}

	handleContactInfo = () => {
		const {
			contact,
			name,
			email,
			loggedIn,
		} = this.state
		if (this.props.resetError !== undefined) {
			this.props.resetError();
		}
		this.setState({
			menuMessage:undefined,
			loadingContactInfo:true,
			errorDisplay:''
		})
		const tempState = {
			name:name,
			contact:contact,
			email: email
		}
		const check = this.validateInput(tempState)
		if(check) {
			if( loggedIn ) {
				this.submitUserinfo(this.state.user.username);
			} else { // guest login, secret sign up/resend code for OTP
				Negosyo.getUser(contact)
				.then((user)=>{
					if(user.status==="Active" ){
						if(user.logintype==="Password") {
							clearTimeout(this.state.timeOut1)
							const timeOut1 = setTimeout( ()=>{
								this.setState({errorDisplay:''})
							}, 8000)

							this.setState({
								loadingContactInfo:false,
								errorDisplay:"Account already exists. Please sign in to proceed.",
								timeOut1:timeOut1
							})
						}else {
							this.submitUserinfo(user.username)
						}

					}else if(user.status==="Inactive") {
						/* forgot password will handle the Inactive and aws missing bug, so just direct them to forgot-password
						 * like in the forgot-password Inactive handling this is a temporary measure to handle the fall out
						 * because we don't handle when aws register or aws login w/ otp fails
						 */
						if( user.logintype==="Password" ) {
							this.setState({
								loadingContactInfo:false,
								message:(
									<React.Fragment>
										There was an attempt to use this number in the past.  For your safety, kindly reset your password <Link to="/forgot-password/" >here</Link>
									</React.Fragment>
								)
							})
						}else {
							/*Negosyo.register is for otp users that are missing aws account and this is a stopgap measure to fix the missing aws account bug
							*/
							const password = ( Math.floor(Math.random()*9000000)+1000000 ).toString()
							Negosyo.register(user.username, password )
							.then(()=>{
								this.handleNewOTPUser(contact, user.username);
							}).catch(e =>{
								if(
									e.message.toLowerCase()==="invalid lambda function output : invalid json" ||
									e.message.toLowerCase()==="user already exists"
								){
									this.handleNewOTPUser(contact, user.username);
								}else {
									this.setState({
										loadingContactInfo:false,
										errorDisplay:"Error occurred, please try again.",
									})
									//alert(e.message)
								}
							})
						}


					}else if(user.status==="None") {
						Negosyo.registerUser(contact, "OTP", name)
						.then((data)=>{
							const password = ( Math.floor(Math.random()*9000000)+1000000 ).toString()
							if(data.status==="OK") {
								Negosyo.register(data.username, password )
								.then(()=>{
									this.submitUserinfo(data.username)
								}).catch(e =>{
									if(e.message.toLowerCase()==="invalid lambda function output : invalid json"){
										//act like everything is normal
										this.submitUserinfo(data.username)
									}else {
										this.setState({
											loadingContactInfo:false,
											errorDisplay:"Error occurred, please try again.",
										})
									}
								});
							}else {
								this.setState({
									loadingContactInfo:false,
									errorDisplay:"Error occurred, please try again.",
								})
							}
						}).catch((e)=>{
							this.setState({
								loadingContactInfo:false,
								errorDisplay:"Error occurred, please try again.",
							})
						})
					}else {
						this.setState({
							loadingContactInfo:false,
							errorDisplay:"Error occurred, please try again.",
						})
					}
				}).catch((err)=>{
					this.setState({
						loadingContactInfo:false,
						errorDisplay:"Error occurred, please try again.",
					})
				})

			}
		}else {
			this.setState({loadingContactInfo:false})
		}
	}

	handleNewOTPUser = ((contact, username) => {
		Negosyo.getOTPCode(contact, username)
		.then((response)=>{
			if(response.status==="OK") {
				this.submitUserinfo(username);
			}else {
				this.setState({
					loadingContactInfo:false,
					errorDisplay:"Error occurred, please try again.",
				})
			}

		}).catch(e =>{
			this.setState({
				loadingContactInfo:false,
				errorDisplay:"Error occurred, please try again.",
			})
		})
	});

	handleInputChange = (e, { name, value }) => {
		if (name === "contact" || name === "email") {
			value = value.replace(/\s/g,"");
		}

		this.setState({ [name]: value })
		if( value==='' && name !== "email" ) {
			const message = name + " must not be blank"
			this.setState(prevState => ({
				errorMessage: {
					...prevState.errorMessage,
					[name] : message
				}
			}))
		} else {
			const message = undefined
			this.setState(prevState => ({
				errorMessage: {
					...prevState.errorMessage,
					[name] : message
				}
			}))
		}
		/*
		this.setState({ [name]: value }, function() {

		})
		*/
	}

	validateInput = (inputobj) => {
		var haserror = false;
		for( let key of Object.keys(inputobj) ) {
			if(inputobj[key]==='' || inputobj[key]===undefined ) {
				if (key !== "email") {
					this.setState( prevState=>({
						errorMessage: {
							...prevState.errorMessage,
							[key]:"Required"
						}
					}));
					haserror = true;
				}
			} else if(key==="contact") {
				const pattern = /^(0|\+63)(8|9)([0-9]{9})$/g
				const result = pattern.test(inputobj[key])
				if(!result) {
					haserror = true;
					this.setState(prevState => ({
						errorMessage: {
							...prevState.errorMessage,
							contact : "Invalid mobile number"
						}
					}))
				}
			} else if (key === "email") {
				const emailpattern = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/g
				const emailresult = emailpattern.test(inputobj[key])
				if(!emailresult) {
					haserror = true;
					this.setState(prevState => ({
						errorMessage: {
							...prevState.errorMessage,
							email : "Invalid email address"
						}
					}))
				}


			}
		}
		return haserror === false;
	}
/*
	handleSubmit = () => {
		const check = this.validateInput()
		if(check) {
			var submitData = {
				fields: []
			};
			var index = 0;
			var valindex = 0;
			while (index < this.props.fieldList.length) {
				submitData.fields.push({
						"label": this.props.fieldList[index].label,
						"value": this.state["index"+index]
					});
				index++;
			}
			this.props.handleSubmit(submitData);
		}else {
			this.setState({loading:false})
		}

	}
*/
	changeLoginStage = (newStage) =>{
		this.setState({
			loginStage:newStage
		},()=>{
			//this.scrollToTopSection()
		})
	}


	render() {
		const {
			success,
            name,
            email,
            contact,
			errorDisplay,
			loading,
			errorMessage,
            loggedIn,
            loadingContactInfo,
			loadingContact,
			loginStage
		} = this.state
		const {
			handleInputChange,
            changeLoginStage,
            handleContactInfo,
            handleUserLogIn
		} = this
		const {
            handleBackButton,
			shortenForm
		} = this.props

		const disableaction = (this.props.hasOwnProperty("disabled")?this.props.disabled:false)||loadingContact || loadingContactInfo;

		return (
            <React.Fragment>
                { (loggedIn || loginStage==="proceed") && (
                    <React.Fragment>
						<Header className={styles.header}>
							{loggedIn?"Loading...":"Proceed as Guest"}
						</Header>

						<Form>
							<Form.Input
								label="Full Name*"
								placeholder="Name"
								value={name}
								error={errorMessage.name}
								name="name"
								onChange={handleInputChange}
								className={styles.form}
								disabled={disableaction}
								loading={loadingContact}
							/>
							<Form.Input
								label="Mobile #*"
								placeholder="(e.g. +639XXXXXXXXX, 09XXXXXXXXX)"
								value={contact}
								error={errorMessage.contact}
								name="contact"
								onChange={handleInputChange}
								className={styles.form}
								disabled={disableaction}
								loading={loadingContact}
							/>
							<Form.Input
								label="Email"
								placeholder="Email"
								value={email}
								error={errorMessage.email}
								name="email"
								type="email"
								onChange={handleInputChange}
								className={styles.form}
								disabled={disableaction}
								loading={loadingContact}
							/>
						</Form>
						{errorDisplay !== "" &&
							<Message negative className={styles.msg}>
								<Message.Header>{errorDisplay}</Message.Header>
							</Message>
						}
						{handleBackButton &&
							<Button
								content={"Back"}
								color={backColor}
								onClick={handleBackButton}
								disabled={disableaction}
								className={styles.form}
								name={"loginBackButton"}
							/>
						}
                        <Button
                            content={"Proceed"}
                            onClick={handleContactInfo}
                            color={confirmationColor}
                            loading={disableaction}
                            disabled={disableaction}
                            className={styles.mainButton}
                            name={"loginProceedButton"}
                        />

                    </React.Fragment>
                )}
                {!loggedIn && (
                    <div className={`${styles.leftAlign}`}>
                        {loginStage==="sign up" && (
                            <React.Fragment>
                                <SignUpForm
									disabled={disableaction}
                                    loginType="Password"
                                    backFunc={handleBackButton}
                                    handleSubmit={()=>{
                                        handleUserLogIn()
                                    }}
									shortenForm={shortenForm}
                                />
                            </React.Fragment>
                        )}
                        {loginStage==="sign in" && (
                            <SignInForm
								disabled={disableaction}
                                backFunc={handleBackButton}
                                handleSubmit={()=>{
                                    handleUserLogIn()
                                }}
								shortenForm={shortenForm}
                            />
                        )}
                        { (this.props.allowSignUp || this.props.allowGuest) &&
                            <div>
                                <br/>
                                <p className={styles.text}>
                                    {(loginStage !=="sign up" && this.props.allowSignUp) && (
                                        <React.Fragment>
                                            No account yet?
                                            <Button
                                                content="Sign Up"
												disabled={disableaction}
                                                className={styles.mainButton}
                                                color={secondaryButtonColor}
                                                onClick={()=>{
                                                    changeLoginStage("sign up")
                                                }}
                                                name={"switchToSignUp"}
                                            />
                                            <br/>
                                        </React.Fragment>
                                    )}
                                    {loginStage !=="sign in" && (
                                        <React.Fragment>
                                            Have an Account?
                                            <Button
                                                content="Sign in"
												disabled={disableaction}
                                                className={styles.mainButton}
                                                color={secondaryButtonColor}
                                                onClick={()=>{
                                                    changeLoginStage("sign in")
                                                }}
                                                name={"switchToSignIn"}
                                            />
                                            <br/>
                                        </React.Fragment>
                                    )}
                                    {(loginStage !=="proceed" && this.props.allowGuest) && (
                                        <React.Fragment>
                                            Proceed without an account?
                                            <Button
												loading={disableaction}
												disabled={disableaction}
                                                content="Proceed as Guest"
                                                className={styles.mainButton}
                                                color={redirectGuestCheckoutColor}
                                                onClick={()=>{
                                                    changeLoginStage("proceed")
                                                }}
                                                name={"switchToGuestProceed"}
                                            />
                                        </React.Fragment>
                                    )}
                                </p>
                            </div>
                        }
                    </div>
                )}

            </React.Fragment>
		)
	}
}